<script setup lang="ts">
import { computed, onBeforeMount, reactive } from 'vue';
import i18n from '@/i18n';
import { SV_LIBRARY_HOTEL, HOTEL_MAPPING, HOTEL_CONTENT, PDF_HTML, E_DOC, INVOICE, ROOMING_LIST, EMAIL_TEMPLATE_EN, EMAIL_TEMPLATE_FR } from '@/constants';
import { usePromoComposable } from '@/components/admin/usePromoComposable';
import { useItemConfigurationStore } from '@/store/ItemConfigurationStore';
import { useToast } from 'primevue/usetoast';
import SplitterPanel from 'primevue/splitterpanel';
import Splitter from 'primevue/splitter';
import Toast from 'primevue/toast';
import AdminSetupUrl from './AdminSetupUrl.vue';

const { canEditAdminSetup } = usePromoComposable();
const configurationModule = useItemConfigurationStore();

const payload = reactive({
  urlType: '',
  link: ''
});

const toast = useToast();

const link = reactive({
  [SV_LIBRARY_HOTEL]: '',
  [HOTEL_MAPPING]: '',
  [HOTEL_CONTENT]: '',
  [PDF_HTML]: '',
  [E_DOC]: '',
  [INVOICE]: '',
  [ROOMING_LIST]: '',
  [EMAIL_TEMPLATE_EN]: '',
  [EMAIL_TEMPLATE_FR]: ''
});

const status = computed(() => configurationModule.selectStatus);
const itemUrl = computed(() => configurationModule.selectItemUrl);

onBeforeMount(() => {
  configurationModule.getUrlConfigurationItem();
});

const handleSubmit = async (type) => {
  payload.urlType = type;
  payload.link = link[type];
  await configurationModule.updateUrlByUrlType(payload);
  if (status.value === true) {
    toast.add({ severity: 'success', summary: '', detail: i18n.global.t('notification.add_successfully'), life: 3000 });
  } else {
    toast.add({ severity: 'error', summary: '', detail: i18n.global.t('notification.unexpected_error'), life: 5000 });
  }
};
</script>

<template>
  <Toast position="top-left" group="tl" />
  <Splitter v-if="payload">
    <SplitterPanel>
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.softVoyage_hotel_url')" :canEdit="canEditAdminSetup" v-model:link="link.SV_LIBRARY_HOTEL" :typeLink="SV_LIBRARY_HOTEL" :itemUrl="itemUrl?.svLibraryHotelUrl" @handleSubmit="handleSubmit($event)" />

      <!-- hotel mapping url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.hotel_mapping_url')" :canEdit="canEditAdminSetup" v-model:link="link.HOTEL_MAPPING" :typeLink="HOTEL_MAPPING" :itemUrl="itemUrl?.hotelMappingUrl" @handleSubmit="handleSubmit($event)" />

      <!-- hotel content url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.hotel_content_url')" :canEdit="canEditAdminSetup" v-model:link="link.HOTEL_CONTENT" :typeLink="HOTEL_CONTENT" :itemUrl="itemUrl?.hotelContentUrl" @handleSubmit="handleSubmit($event)" />

      <!-- pdf html url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.pdf_html_url')" :canEdit="canEditAdminSetup" v-model:link="link.PDF_HTML" :typeLink="PDF_HTML" :itemUrl="itemUrl?.pdfHtmlUrl" @handleSubmit="handleSubmit($event)" />

      <!-- edoc url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.edoc_url')" :canEdit="canEditAdminSetup" v-model:link="link.E_DOC" :typeLink="E_DOC" :itemUrl="itemUrl?.eDocUrl" @handleSubmit="handleSubmit($event)" />

      <!-- invoice url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.invoice_url')" :canEdit="canEditAdminSetup" v-model:link="link.INVOICE" :typeLink="INVOICE" :itemUrl="itemUrl?.invoiceUrl" @handleSubmit="handleSubmit($event)" />

      <!-- rooming list url -->
      <AdminSetupUrl :titleUrl="$t('promos.urlAdmin.rooming_list_url')" :canEdit="canEditAdminSetup" v-model:link="link.ROOMING_LIST" :typeLink="ROOMING_LIST" :itemUrl="itemUrl?.roomingListUrl" @handleSubmit="handleSubmit($event)" />

      <!-- email template english url -->
      <AdminSetupUrl
        :titleUrl="$t('promos.urlAdmin.email_template_english_url')"
        :titleUrlFr="$t('promos.urlAdmin.email_template_french_url')"
        :canEdit="canEditAdminSetup"
        v-model:link="link.EMAIL_TEMPLATE_EN"
        v-model:linkFr="link.EMAIL_TEMPLATE_FR"
        :typeLink="EMAIL_TEMPLATE_EN"
        :typeLinkFr="EMAIL_TEMPLATE_FR"
        :itemUrl="itemUrl?.emailTemplateEnUrl"
        :itemUrlFr="itemUrl?.emailTemplateFrUrl"
        @handleSubmit="handleSubmit($event)"
      />
    </SplitterPanel>
  </Splitter>
</template>
